export default __webpack_public_path__ + "static/media/Mazhar Haroon.26fc6171.jpeg";